﻿import { WrapperGS } from '../core/WrapperGS';
import { EventGS, EventGSToken } from '../core/EventsGS';

export class ImageGS extends WrapperGS<HTMLImageElement>
{
    static ForHTMLElement(el: HTMLElement): boolean { return el.nodeName.toLowerCase() === "img"; }

    private readonly _onLoadedToken: EventGSToken;
    public readonly onLoaded: EventGS;

    constructor(el: HTMLImageElement|string)
    {
        super(el);
        this._onLoadedToken = new EventGSToken(() => { this.el.addEventListener('load', () => this._onLoadedToken.invoke()); });
        this.onLoaded = new EventGS(this._onLoadedToken);
    }

    public get src() { return this.el.src; }
    public set src(value: string) { this.el.src = value; }
}
WrapperGS.ExtendComponentsByHTMLElement(ImageGS);
